export const uz = {
    id: 'ID',
    add: 'Qoʻshish',
    address: 'Manzil',
    cancel: 'Bekor qilish',
    confirm: 'Ishonchingiz komilmi?',
    contract: 'Shartnoma',
    email: 'Elektron pochta',
    firstname: 'Ism',
    lang: "Uz",
    lastname: 'Familiya',
    login: 'Kirish',
    loginTitle: 'Tizimga kirish',
    name: 'Nomi',
    networkError: 'Serverga ulanishda xato',
    no: 'Yoʻq',
    noData: 'Maʼlumot yoʻq',
    noRoutes: 'Administrator sizga marshrut koʻrsatmagan',
    ok: 'Ha',
    password: 'Parol',
    phone: 'Telefon raqami',
    price: 'Narxi',
    product: 'Mahsulot',
    registration: 'Roʻyxatdan oʻtish',
    repeatThePassword: 'Parolni takrorlang',
    required: 'Iltimos, {{input}}ni kiriting!',
    role: 'Rola',
    save: 'Saqlash',
    store: 'Ombor',
    update: 'Oʻzgartirish',
    username: 'Foydalanuvchi nomi',
    ROLE_ADMIN: "ADMIN",
    ROLE_USER: "FOYDALANUVCHI",
    action: "Amallar",
    search: "{{name}}ni qidiring",
    year: "Yil",
    month: "Oy",
    day: "Kun",
    hour: "Soat",
    minute: "Daqiqa",
    second: "Soniya",
    sectionAccess: "Boʻlimga kirish",
    delete: 'Oʻchirish',
    select: 'Tanlash',
    from: 'dan',
    to: 'ga',
    selectPage: 'Sahifani tanlang',
    nds: 'QQS',
    noPermission: 'Ruxsat yoʻq',
    permission: 'Ruxsat',
    empty: '(boʻsh)',
    fullName: 'Toʻliq ismi',
    users: 'Foydalanuvchilar',
    region: 'Hudud',
    inn: 'STIR',
    code: "Kod",
    mfo: 'MFO',
    hide: 'Yashirish',
    history: 'Tarix',
    createdDate: 'Yaratilgan sana',
    size: 'Hajmi',
    download: 'Yuklab olish',
    delete_confirm: 'Oʻchirmoqchi ekanligingizga ishonchingiz komilmi?',
    status: 'Holati',
    bank: 'Bank',
    productName: 'Mahsulot nomi',
    invoiceNum: 'Hisob-faktura raqami',
    expirationDate: 'Muddati',
    document: "Hujjat",
    act: "Akt",
    acceptAccount: "Tasdiqlagan Akkaunt",
    returnAct: "Qaytarilgan Akt",
    returnActAccepted: "Принятые возврат акта",
    selectSumma: "Tanlangan summa",
    summaWithoutVat: "QQS siz summa",
    urgentToView: "Shoshilinch ko'rish",
    sync: "Sinxronlash",
    selectDateRange: "Sana oraligʻini tanlang",
    unmatched: "Mosliklar bekor qilindi",
    errors: "Xatolar",
    expansion: "Qo'shimcha",
    empowerment: "Ishonchnoma",
    withoutEmpowerment: "Yuridik shaxs",
    empowermentNeedsMatched: "Avval «Solishtirilgan» = «Ha» ni tanlang",
    scoringResult: {
        "0": "Past xavf darajasi",
        "1": "Yuqori xavf darajasi",
        "undefined": "Hisobga olish bosqichida",
        "null": "Hisobga olish bosqichida"
    },
    organization: "Organizatsiya",
    organizations: "Organizatsiyalar",
    switchOrganization: "Organizatsiyani almashtirish",
    organizationSwitched: "Organizatsiya almashtirildi",
    assign: "Biriktirish",
    unassign: "Olib tashlash",
    defaultOrganization: "Asosiy",
    noOrganization: "Organizatsiya biriktirilmagan",
    customer: "Xaridor",
    setDefault: "Asosiy qilish",
    unassignConfirm: "Biriktirishni bekor qilasizmi?",
    all: "Barchasi",
    regularInvoices: "Oddiy ESF",
    hybridInvoices: "Gibrid ESF",
    hybrid: "Gibrid",
    regular: "Oddiy",
    documentType: "Hujjat turi",
    hybridStatus210: "Yetkazib beruvchi yubordi, qabul qilinishi kutilmoqda",
    hybridStatus220: "Yetkazib beruvchi tomonidan bekor qilingan",
    hybridStatus230: "Mas'ul shaxs tomonidan rad etilgan",
    hybridStatus240: "Mas'ul shaxs tomonidan qabul qilingan",
    hybridStatus250: "Mas'ul shaxs: qaytarilgunga qadar",
    hybridStatus260: "Mas'ul shaxs: topshirilgan",
    hybridStatus270: "Xaridor tomonidan rad etilgan",
    hybridStatus280: "Xaridor tomonidan qabul qilingan",
    hybridStatus290: "Mas'ul shaxs tomonidan qaytarilgan",
    hybridStatus300: "Yetkazib beruvchi tomonidan qaytarilgan",
    hybridStatus999: "Soliq qo'mitasi tomonidan bekor qilingan",
    hybridEmpowermentNotSupported: "Ishonchnomali gibrid ESFni qabul qilish hozircha qo'llab-quvvatlanmaydi",
    hybridOnlyIncomeAct: "Gibrid ESF faqat kirim akti bilan taqqoslanishi mumkin",
}
